export const environment = {
  apiUrl: 'https://api-dev.dostifycrm.com',
    uiUrl:'https://dev.dostifycrm.com',
    imagePath:'https://aec5e78c042a4647486e17a2b0df1fc3.r2.cloudflarestorage.com/dostifycrm',
    publicCloudFlareUrl:'https://pub-5beae5c4ac1044cdb61fbbd6477011b3.r2.dev',
    socketUrl: 'https://api-dev.dostifycrm.com',
  useSocketNotifications: true,
  client_max_body_size:20,
  client_max_file_pieces:5,
  firebase: {
    apiKey: 'AIzaSyB1Jch3F7HYMp-CqMw-SF5RtvzZjs9pnyA',
    authDomain: 'crm-2024-a2523.firebaseapp.com',
    projectId: 'crm-2024-a2523',
    storageBucket: 'crm-2024-a2523.firebasestorage.app',
    messagingSenderId: '922902073711',
    appId: '1:922902073711:web:c49e34cd3e356db0a8989a',
    measurementId: 'G-MTMB5N5E7N',
    
  },
  vapidKey:
    'BMpGCHyevL80Mkzr_qnMqDoS9xih4kiyOSGXaldPJmc-7CZ5O0c-6GH6M_nMoMIEZBYd_o-NmE6Y6oobJ-tFMdk',
    grapeJsKey: '7c8eddaaa1954dc39979ee45032a193a28af491c04814879bde0558c19d4a53c',

    telnyx: {
      enabled: true,
      stunServers: [
        'stun:stun.telnyx.com:3478',
        'stun:stun.l.google.com:19302'
      ]
    },
    
    // Company phone number (fallback for caller ID) 
    companyPhoneNumber: '+447822001896', // Let Telnyx use default caller ID
    
    production: false
  };
